import { useState } from 'react';
import { isValidDomain } from '../../validation/PropertyValidations';
import { EditableControls } from 'foundations-components/transitional/components/EditableControls';
import DomainInput from './DomainInput';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function NewValue({
  domains,
  onSave,
  onCancel,
  showAutoSaveText
}) {
  const [value, setValue] = useState('');
  const duplicateValue = domains.includes(value);
  const isSaveDisabled = !value || !isValidDomain(value) || duplicateValue;
  const confirmLabel = showAutoSaveText ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.PropertyInputMultipleDomain.save"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.PropertyInputMultipleDomain.apply"
  });
  return /*#__PURE__*/_jsxs(Grid, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 8
      },
      children: /*#__PURE__*/_jsx(EditableControls, {
        onCancel: onCancel,
        onSave: () => onSave(value),
        saveDisabled: isSaveDisabled,
        use: "flush",
        saveLabel: confirmLabel,
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(DomainInput, {
          autoFocus: true,
          onChange: e => setValue(e.target.value),
          value: value
        })
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 4
      }
    })]
  });
}
export default NewValue;